import React from "react";

import classes from "./HeartSpin.module.css";

const HeartSpin = (props) => {
    return (
        <div className={classes.ldsHeart}>
            <div></div>
        </div>
    );
};

export default HeartSpin;